import { supabase } from '../../lib/supabaseClient';

export type FanPost = {
  id: string;
  author_name: string | null;
  message: string;
  status: 'pending' | 'approved' | 'rejected';
  ip_hash: string | null;
  created_at: string;
  moderated_at: string | null;
  moderated_by: string | null;
};

export type FanPostImage = {
  id: string;
  fan_post_id: string;
  storage_path: string;
  sort_order: number;
  created_at?: string;
};

export async function getPendingFanPosts() {
  const { data, error } = await supabase
    .from('fan_posts')
    .select('*')
    .eq('status', 'pending')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []) as FanPost[];
}

export async function getAllFanPostsAdmin() {
  const { data, error } = await supabase
    .from('fan_posts')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []) as FanPost[];
}

export async function getApprovedFanPosts() {
  const { data, error } = await supabase
    .from('fan_posts')
    .select('*')
    .eq('status', 'approved')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []) as FanPost[];
}

export async function getFanPostImages(postId: string) {
  const { data, error } = await supabase
    .from('fan_post_images')
    .select('*')
    .eq('fan_post_id', postId)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as FanPostImage[];
}

export async function approveFanPost(id: string) {
  const { error } = await supabase
    .from('fan_posts')
    .update({ status: 'approved', moderated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}

export async function rejectFanPost(id: string) {
  const { error } = await supabase
    .from('fan_posts')
    .update({ status: 'rejected', moderated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}

export async function deleteFanPost(id: string) {
  const { error } = await supabase.from('fan_posts').delete().eq('id', id);
  if (error) throw error;
}

export async function createFanPost(payload: { author_name?: string; message: string; ip_hash?: string }) {
  const { data, error } = await supabase.from('fan_posts').insert(payload).select('id').single();
  if (error) throw error;
  return data.id as string;
}

export async function addFanPostImage(fan_post_id: string, storage_path: string, sort_order: number) {
  const { error } = await supabase.from('fan_post_images').insert({ fan_post_id, storage_path, sort_order });
  if (error) throw error;
}

const BUCKET = 'fan_uploads';
export function getFanImagePublicUrl(path: string) {
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function uploadFanImage(postId: string, file: File) {
  const uid = crypto.randomUUID();
  const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  const path = `${postId}/${uid}.${ext}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, { upsert: false });
  if (error) throw error;
  return path;
}
